/** Shared console + CustomEvent callbacks for web/admin SPA error UI hooks. */
export function createBrowserErrorCallbacks() {
    return {
        log: (level, message, details) => {
            const logMessage = `🚨 ${message}`;
            if (level === 'error') {
                console.error(logMessage, details);
                return;
            }
            if (level === 'warn') {
                console.warn(logMessage, details);
                return;
            }
            console.log(logMessage, details);
        },
        onAuthError: ({ message }) => {
            console.warn('🔐 Ошибка авторизации - требуется повторный вход');
            window.dispatchEvent(new CustomEvent('auth-error', { detail: { message } }));
        },
        onApiError: ({ title, message }) => {
            console.warn(`⚠️ ${title}: ${message}`);
            window.dispatchEvent(new CustomEvent('api-error', { detail: { title, message } }));
        },
    };
}
